import { Pipe, PipeTransform } from '@angular/core';
import { ProcessingStatus } from 'src/app/core/enums/lead/processing-status.enum';
import { UserPermission } from 'src/app/core/enums/user/user-permission.enum';
import { LeadHead } from 'src/app/core/models/lead/lead-head.model';
import { UserProfile } from 'src/app/core/models/user/user-profile.model';
import { HasPermissionPipe } from 'src/app/shared/user/pipes/has-permission.pipe';


@Pipe({
    name: 'showAutoAssignButton',
    standalone: false
})
export class ShowAutoAssignButtonPipe implements PipeTransform {

  constructor(private hasPermissionPipe: HasPermissionPipe) {
  }

  transform(value: [LeadHead, UserProfile | null | undefined]): boolean {
    if (!value[0]) return false
    return this.hasPermissionPipe.transform(value[1], UserPermission.OfferOrAssignLeadsToAnyAgent) &&
      ![ProcessingStatus.Done, ProcessingStatus.Assigned, ProcessingStatus.PendingOfferConfirmation].includes(value[0].processingStatus)
  }

}
